import { useUser } from 'hooks'
import { useStats } from '../ctx/stats'
import { isAndroidPlatform, isStatsInspect } from '../utils'
import { isInternalUser } from '@fable/utils'
import { useParams } from 'react-router-dom'

export const useStatsPermission = () => {
  const params = useParams()
  const isLegacyUserId = !params.id?.length

  const { user } = useUser()
  const [statsUserId, privacy, platform, isSelfView] = useStats((s) => [
    s.statsUserId,
    s.stats?.privacy,
    s.stats?.platform,
    s.isSelfView,
  ])

  const isAndroid = isAndroidPlatform(platform)

  if (isStatsInspect && isInternalUser(user)) {
    return {
      isPrivate: false,
      isStatsOwner: true,
      isAuthStatsOwner: true,
      isAndroid,
      isInspecting: true,
    }
  }

  const isStatsOwner = isLegacyUserId ? user?.id === statsUserId : isSelfView
  const isPrivate = !isStatsOwner && privacy === 'me'
  const isAuthStatsOwner = isStatsOwner && user?.id === statsUserId

  return {
    isPrivate,
    isStatsOwner,
    isAndroid,
    isAuthStatsOwner,
  }
}
